<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M1 4H16" stroke="#E5E5E5" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M4 4V13" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M13 4V13" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M2.5 13H5.5" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M11.5 13H14.5" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
</svg>
